import { render, staticRenderFns } from "./IconTrailer.vue?vue&type=template&id=5b367d1c&"
import script from "./IconTrailer.vue?vue&type=script&lang=ts&"
export * from "./IconTrailer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports